import React, { Component } from "react";
import PortfolioContextWrapper, { PortfolioContext } from "@my-dld/contexts/PortfolioContext";
import Strings from "@my-dld/assets/strings";
import { EjariPropertyType } from "@eres/ejari-api/Entity";
import LeaseTable from "@my-dld/components/Portfolio/LeaseTable";
import { UnitSystem } from "@my-dld/utils/UnitUtils";
import CardNoData from "@my-dld/components/CardNoData";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import LeaseCard from "../../../components/Portfolio/LeaseCard";
import { getAppServices } from "@10x/coreapp/index";
import Properties from "@10x/rentalvaluation/web/screens/Properties";

interface Props {

}

interface State {
	unit: UnitSystem;
}

class LeasedProperties extends Component<Props, State> {
	static contextType = PortfolioContext;
	context!: React.ContextType<typeof PortfolioContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			unit: getAppServices().storeService.getStore().getState().User.unit,
		};
	}

	render() {
		const { lands, units, villas, buildings } = this.context.leases;
		const isDataFound = ( lands && lands.length > 0 ) || ( buildings && buildings.length > 0 ) ||
			( villas && villas.length > 0 ) || ( units && units.length > 0 );
		return <ListGridDataView
			dataAvailable={ isDataFound }
			title={ Strings.i_am_tenant }
			onUnitSystemChange={ this.onUnitChange }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }>
		</ListGridDataView>;
	}

	private onUnitChange = ( unit: UnitSystem ) => {
		this.setState( { unit: unit } );
	};

	private renderListView = () => {
		const { lands, units, villas, buildings, info, version } = this.context.leases;
		const hasData = info.all.count > 0;
        return <React.Fragment>
			{ hasData && <>
                <div className="tabs mydld-property-detail-tab">
                    <nav className="transformer-tabs">
                        <ul id="myTab" role="tablist">
                            { lands && lands.length > 0 &&
                                <li className="nav-item">
                                <a href="#" className="nav-link" id="land_tab" data-bs-toggle="tab" data-bs-target="#land_tab_pane" type="button" role="tab" aria-controls="land_tab_pane" aria-selected="true">Land <span className="badge bg-light">{`${lands!.length}`}</span></a>
                                </li>
                            }
                            {   buildings && buildings.length > 0 &&
                                <li className="nav-item">
                                <a href="#" className="nav-link" id="building_tab" data-bs-toggle="tab" data-bs-target="#building_tab_pane" type="button" role="tab" aria-controls="building_tab_pane" aria-selected="false">Building / Villa <span className="badge bg-light">{`${buildings!.length}`}</span></a>
                                </li>
                            }
                            { villas && villas.length > 0 &&
                                <li className="nav-item">
                                <a href="#" className="nav-link" id="villa_tab" data-bs-toggle="tab" data-bs-target="#villa_tab_pane" type="button" role="tab" aria-controls="villa_tab_pane" aria-selected="false">Villa <span className="badge bg-light">{`${villas!.length}`}</span></a>
                                </li>
                            }
                            { units && units.length > 0 &&
                                <li className="nav-item">
                                <a href="#" className="nav-link active" id="unit_tab" data-bs-toggle="tab" data-bs-target="#unit_tab_pane" type="button" role="tab" aria-controls="unit_tab_pane" aria-selected="false">Unit <span className="badge bg-light">{`${units!.length}`}</span></a>
                                </li>
                            }
                        </ul>
                    </nav>
                    <div className="tab-content d-block pt-0 " id="myTabContent">
				        { lands && lands.length > 0 &&
                            <div className="tab-pane fade" id="land_tab_pane" role="tabpanel" aria-labelledby="land_tab">
                                <div className="position-relative w-100 mb-3">
                                    <label className="sr-only" htmlFor="landSearch">Search</label>
                                    <input type="text" id="landSearch" className="form-control search-field-icon" placeholder="Search" />
                                    <button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button>
                                    <button className="btn btn_1 txt-search-btn" type="button">{Strings.search}</button>
                                </div>
                               <LeaseTable
				        		    key={ version + "-lnd" }
				        		    properties={ lands }
				        		    type={ EjariPropertyType.LAND }
                                    unit={this.state.unit} />
                            </div>
				        }
				        { buildings && buildings.length > 0 &&
                            <div className="tab-pane fade" id="building_tab_pane" role="tabpanel" aria-labelledby="building_tab">
                                <div className="position-relative w-100 mb-3">
                                    <label className="sr-only" htmlFor="buildingSearch">Search</label>
                                    <input type="text" id="buildingSearch" className="form-control search-field-icon" placeholder="Search" />
                                    <button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button>
                                    <button className="btn btn_1 txt-search-btn" type="button">{Strings.search}</button>
                                </div>
                                <LeaseTable
				        		    key={ version + "-buildings" }
				        		    properties={ buildings }
				        		    type={ EjariPropertyType.BUILDING }
                                    unit={this.state.unit} />
                            </div>
				        }
				        { villas && villas.length > 0 &&
                           <div className="tab-pane fade" id="villa_tab_pane" role="tabpanel" aria-labelledby="villa_tab">
                                <div className="position-relative w-100 mb-3">
                                    <label className="sr-only" htmlFor="villaSearch">Search</label>
                                    <input type="text" id="villaSearch" className="form-control search-field-icon" placeholder="Search" />
                                    <button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button>
                                    <button className="btn btn_1 txt-search-btn" type="button">{Strings.search}</button>
                                </div>
                                <LeaseTable
				        		    key={ version + "-villa" }
				        		    properties={ villas }
				        		    type={ EjariPropertyType.VILLA }
                                    unit={this.state.unit} />
                            </div>
				        }
				        { units && units.length > 0 &&
                           <div className="tab-pane fade show active" id="unit_tab_pane" role="tabpanel" aria-labelledby="unit_tab">
                                <div className="position-relative w-100 mb-3">
                                    <label className="sr-only" htmlFor="unitSearch">Search</label>
                                    <input type="text" id="unitSearch" className="form-control search-field-icon" placeholder="Search"/>
                                    <button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button>
                                    <button className="btn btn_1 txt-search-btn" type="button">{Strings.search}</button>
                                </div>
                                <LeaseTable
				        		    key={ version + "-unit" }
				        		    properties={ units }
				        		    type={ EjariPropertyType.UNIT }
                                    unit={this.state.unit} />
                           </div>
				        }
			        </div>
                </div> 
                </> }
			{ !hasData && <CardNoData/> }
		</React.Fragment>;
	};

	private renderGridView = () => {
		const { lands, units, villas, buildings, info, version } = this.context.leases;
		const hasData = info.all.count > 0;
		return <React.Fragment>
			{ hasData && <>
                <div className="tabs mydld-property-detail-tab">
                    <nav className="transformer-tabs">
                        <ul id="myTab" role="tablist">
                            {lands && lands.length > 0 &&
                                <li className="nav-item">
                                    <a href="#" className="nav-link" id="land_tab" data-bs-toggle="tab" data-bs-target="#land_tab_pane" type="button" role="tab" aria-controls="land_tab_pane" aria-selected="true">Land <span className="badge bg-light">{`${lands!.length}`}</span></a>
                                </li>
                            }
                            {buildings && buildings.length > 0 &&
                                <li className="nav-item">
                                    <a href="#" className="nav-link" id="building_tab" data-bs-toggle="tab" data-bs-target="#building_tab_pane" type="button" role="tab" aria-controls="building_tab_pane" aria-selected="false">Building / Villa <span className="badge bg-light">{`${buildings!.length}`}</span></a>
                                </li>
                            }
                            {villas && villas.length > 0 &&
                                <li className="nav-item">
                                    <a href="#" className="nav-link" id="villa_tab" data-bs-toggle="tab" data-bs-target="#villa_tab_pane" type="button" role="tab" aria-controls="villa_tab_pane" aria-selected="false">Villa <span className="badge bg-light">{`${villas!.length}`}</span></a>
                                </li>
                            }
                            {units && units.length > 0 &&
                                <li className="nav-item">
                                    <a href="#" className="nav-link active" id="unit_tab" data-bs-toggle="tab" data-bs-target="#unit_tab_pane" type="button" role="tab" aria-controls="unit_tab_pane" aria-selected="false">Unit <span className="badge bg-light">{`${units!.length}`}</span></a>
                                </li>
                            }
                        </ul>
                    </nav>
                    <div className="tab-content d-block pt-0 " id="myTabContent">
                    
				{ lands && lands.length > 0 &&
                    <div className="tab-pane fade" id="land_tab_pane" role="tabpanel" aria-labelledby="land_tab">
					    <LeaseCard
					    	key={ version + "-lnd" }
					    	properties={ lands }
					    	type={ EjariPropertyType.LAND }
                            unit={this.state.unit} />
                    </div>
				}
				{ buildings && buildings.length > 0 &&
                    <div className="tab-pane fade" id="building_tab_pane" role="tabpanel" aria-labelledby="building_tab">
					    <LeaseCard
					    	key={ version + "-buildings" }
					    	properties={ buildings }
					    	type={ EjariPropertyType.BUILDING }
					    	unit={ this.state.unit }/>
                    </div>
				}
				{ villas && villas.length > 0 &&
                    <div className="tab-pane fade" id="villa_tab_pane" role="tabpanel" aria-labelledby="villa_tab">
					    <LeaseCard
					    	key={ version + "-villa" }
					    	properties={ villas }
					    	type={ EjariPropertyType.VILLA }
                            unit={this.state.unit} />
                    </div>
				}
				{ units && units.length > 0 &&
                    <div className="tab-pane fade show active" id="unit_tab_pane" role="tabpanel" aria-labelledby="unit_tab">
					    <LeaseCard
					    	key={ version + "-unit" }
					    	properties={ units }
					    	type={ EjariPropertyType.UNIT }
					    	unit={ this.state.unit }/>
                    </div>
				}
                </div>
            </div>
			</> }
			{ !hasData && <CardNoData/> }
		</React.Fragment>;
	};
}

export default () => <PortfolioContextWrapper>
	<LeasedProperties/>
</PortfolioContextWrapper>;
